export const required = '^1.97.2';
